<template>
  <section class="search-brand-container">
    <div class="check-link-holder search-brand-wrapper is-centered">
      <button
        v-for="(type, typeIndex) in filterTripsContent.productCategories.items"
        :key="'traveltype' + typeIndex"
        class="check-link search-brand-item is-block"
        :data-type-name="typeNameConcat(type)"
        :value="typeNameConcat(type)"
        :class="{ 'is-active': isActive(type) }"
        :aria-label="type.categoryValue"
        @click="selectedTypes(type)"
      >
        <span class="has-text-center">{{ type.title }}</span>
      </button>
    </div>
  </section>
</template>
<script>
import * as searchConstants from '../../search-constants.js';
import eventBus from '../../vue-functions/event-bus.js';

export default {
  props: ['filterTripsContent', 'locked', 'typesVal'],
  data: function () {
    return {
      buttonActiveClass: 'is-active',
      productCategory: [],
      constants: searchConstants
    };
  },
  watch: {
    typesVal(val) {
      this.productCategory = val;
    }
  },
  created() {
    eventBus.$on('types-clear-values', () => {
      this.clearValues();
    });
    this.productCategory = this.typesVal;
  },
  methods: {
    isActive(type) {
      return this.productCategory.includes(type.categoryValue);
    },
    selectedTypes(type) {
      if (this.productCategory.includes(type.categoryValue)) {
        let spliceKey = this.productCategory.indexOf(type.categoryValue);
        this.productCategory.splice(spliceKey, 1);
      } else {
        this.productCategory.push(type.categoryValue);
      }
      this.$parent.$emit('get-selected-types', this.productCategory);
    },
    typeNameConcat(type) {
      return type.categoryValue;
    }
  }
};
</script>
